<template>
    <div>
        <v-row>
            <v-col class="col-1">
                <v-dialog v-model="dialog" max-width="90%" v-if="qtdCreditos">
                    <template v-slot:activator="{ on }">
                        <v-btn v-if="editable" fab dark color="primary" v-on="on" @click="getCreditosCliente()">
                            <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>

                                    <v-col cols="3">
                                        <v-select
                                            v-model="editedItem.filial_id"
                                            label="Filial"
                                            :items="filiais"
                                        >
                                        </v-select>
                                    </v-col>

                                    <v-col cols="3">
                                        <v-text-field v-model="editedItem.descricao"
                                                      label="Descrição do display"
                                                      placeholder="Ex. Fruteira"></v-text-field>
                                    </v-col>

                                    <!--                  <v-col cols="3" v-if="!editedItem.id">-->
                                    <!--                    <v-text-field v-model="editedItem.codigo" label="Código"></v-text-field>-->
                                    <!--                  </v-col>-->
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text
                                   @click="save"
                                   class="ma-2"
                                   :loading="loading"
                                   :disabled="loading"
                            >Salvar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialog" max-width="40%" v-if="!qtdCreditos">
                    <template v-slot:activator="{ on }">
                        <v-btn v-if="editable" fab dark color="primary" v-on="on" @click="getCreditosCliente()">
                            <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <div class="text-center text--primary text-lg-body-1 pa-12">
                                É necessário fazer o pagamento do display para pode inserir.
                                Entre em contato para que possamos enviar um boleto, assim que o
                                valor for compensado, a inserção de um novo display estará liberada.
                            </div>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>

            <v-col
                v-if="editable"
                class="col-3 offset-2"
            >
                <p class="text-h6">
                    Código de cliente: <span class="orange--text text--darken-4">{{ clientCode }}</span>
                    <!--                Código de cliente: <span class="blue darken-2 white&#45;&#45;text">{{clientCode}}</span>-->
                </p>
            </v-col>

            <v-col
                class="col-4 offset-2"
                :class="editable ? 'offset-2' : 'offset-7'"
            >

                <form v-on:submit.prevent="getFromApi()">
                    <v-text-field
                        class="pa-0"
                        v-model="filters.quickSearch"
                        outlined
                        autocomplete="off"
                        label="Quick search"
                        placeholder="código ou descrição"
                        :append-icon="'mdi-magnify'"
                        hint="código ou descrição"
                        dense
                    ></v-text-field>
                </form>

            </v-col>
        </v-row>

        <!--        :show-select="showSelect"-->
        <v-data-table
            :show-select="showSelect"
            v-model="checkedLocal"
            :headers="headers"
            :items="items"
            item-key="id"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhum registro encontrado"
            dense
            show-current-page="true"
            :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  'items-per-page-options': [5, 10, 30, 70, 100],
                }"
            :items-per-page="30"
            group-by="filial_nome"
        >
            <template v-slot:header.data-table-select="{ value, indeterminate }"></template>
            <template v-slot:item.data-table-select="{ item, isSelected, select }">
                <v-simple-checkbox
                    :value="isSelected"
                    :disabled="item.timeline_id != null && item.timeline_id != timelineId"
                    :readonly="item.timeline_id != null && item.timeline_id != timelineId"
                    @click="msgDigiplayerEmUso(item.timeline_id != null && item.timeline_id != timelineId, item.timeline_nome)"
                    @input="select($event)"
                ></v-simple-checkbox>
            </template>

            <template v-if="!showSelect" v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    color="primary"
                >
                    mdi-pencil
                </v-icon>
                <!--        <v-icon-->
                <!--            small-->
                <!--            @click="deleteItem(item)"-->
                <!--            color="error"-->
                <!--        >-->
                <!--          mdi-delete-->
                <!--        </v-icon>-->
            </template>
            <!--            <template v-slot:no-data>-->
            <!--                <v-btn color="primary" @click="getFromApi">Reset</v-btn>-->
            <!--            </template>-->
        </v-data-table>

        <!--        <template v-slot:top>-->
        <!--            <v-toolbar flat>-->
        <v-dialog
            v-model="alertDialog"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    <span class="orange--text">Atenção</span>
                </v-card-title>

                <v-card-text>
                    {{ alertDialogText }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="primary darken-1"
                        text
                        @click="alertDialog = false"
                    >
                        Ok, entendi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--            </v-toolbar>-->
        <!--        </template>-->

    </div>


</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: false,
            default() {
                return [];
            }
        },
        editable: {
            required: false,
            default: true
        },
        showSelect: {
            required: false,
            default: false
        },
        timelineId: {
            required: false,
            default: 0
        },
    },

    data: () => ({
        endpoint: 'players',

        items: [],
        selectedItems: [],
        totalItems: 0,
        options: {},
        dialog: false,
        alertDialog: false,
        alertDialogText: "",
        filters: {
            filial: '',
            quickSearch: '',
        },

        // btn loading
        loader: null,
        loading: false,

        headers: [
            {
                text: 'Ações',
                value: 'actions',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Filial',
                sortable: true,
                value: 'filial_nome'
            },
            {
                text: 'Identificação',
                sortable: true,
                value: 'descricao'
            },
            {
                text: 'Display já em uso pelo slide',
                sortable: true,
                value: 'timeline_nome'
            },
            {
                text: 'Código',
                align: 'start',
                sortable: true,
                value: 'code',
                width: '20%',
            },
        ],
        editedIndex: -1,
        editedItem: {
            // codigo: '',
            descricao: '',
            filial: '',
            // departamento: '',
        },
        defaultItem: {
            // codigo: '',
            descricao: '',
            filial: '',
            // departamento: '',
        },
        departamentos: [{text: '', value: ''}],
        filiais: [{text: '', value: ''}],
        clientCode: '',
        qtdCreditos: 0
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Novo Item' : 'Edição do Item'
        },

        checkedLocal: {
            get: function () {
                return this.value
            },
            set: function (value) {
                this.$emit('input', value)
            }
        }
    },

    watch: {
        dialog(val) {
            val || this.close()
        },

        options: {
            handler() {
                this.getFromApi();
            },
            deep: true,
        },

        selectedItems: {
            handler() {
                this.value = this.selectedItems;
                // this.emitSelectedItems();
            }
        },
    },

    created() {
        this.getDepartamentosFromApi();
        this.getFiliaisFromApi();
        this.showClientCode();
        this.getCreditosCliente();
    },

    methods: {
        msgDigiplayerEmUso(digiplayerEmUso, timeline_nome) {
            if (digiplayerEmUso) {
                alert('O display selecionado já está em uso pelo slide "' + timeline_nome + '", para poder enviar o slide atual para o display, é necessário ir até o slide que está usando o display, desmarcar o display e salvar.');
            }
        },

        emitSelectedItems() {
            this.$emit("emitSelectedItems", this.selectedItems);
        },

        getFromApi() {
            this.loading = true;

            const {sortBy, sortDesc, page, itemsPerPage} = this.options;

            let params = {
                filters: this.filters,
                sortBy: sortBy,
                sortDesc: sortDesc,
                page: page,
                itemsPerPage: itemsPerPage,
            };

            axios.get(this.$store.getters.getUsrEndpoint + '/' + this.endpoint, {params: params})
                .then((response) => {
                        this.items = response.data.items;
                        this.totalItems = response.data.totalItems;

                        this.loading = false;
                    }, (error) => {
                        console.log(error);
                    }
                )
                .catch(error => {
                    console.log(error)
                    // this.errored = true
                })
                .finally(() => this.loading = false)
            ;
        },

        getDepartamentosFromApi() {
            axios.get(this.$store.getters.getUsrEndpoint + '/departamentos')
                .then((response) => {
                        for (var i in response.data.items) {
                            this.departamentos.push({
                                value: response.data.items[i].id,
                                text: response.data.items[i].codigo + ' - ' + response.data.items[i].descricao,
                            });
                        }
                    }, (error) => {
                        console.log(error);
                    }
                )
                .catch(error => {
                    console.log(error)
                    // this.errored = true
                })
            ;
        },

        getFiliaisFromApi() {
            axios
                .get(this.$store.getters.getUsrEndpoint + '/filiais')
                .then((response) => {
                        for (var i in response.data.items) {
                            this.filiais.push({
                                value: response.data.items[i].id,
                                text: response.data.items[i].numero + ' - ' + response.data.items[i].nome,
                            });
                        }

                    }, (error) => {
                        console.log(error);
                    }
                )
                .catch(error => {
                    console.log(error)
                    // this.errored = true
                })
            ;
        },

        getCreditosCliente() {
            axios
                .get(this.$store.getters.getUsrEndpoint + '/players-pagamentos')
                .then((response) => {
                    // response.data.items;
                    this.qtdCreditos = response.data.totalItems;
                }, (error) => {
                    console.log(error);
                })
                .catch(error => {
                    console.log(error)
                    // this.errored = true
                })
            ;
        },

        editItem(item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            // this.editedItem.departamento = this.editedItem.departamento_id;
            this.dialog = true
        },

        deleteItem(item) {
            const index = this.items.indexOf(item)
            if (confirm('Tem certeza que quer remover este item?')) {
                axios
                    .delete('/' + this.endpoint + '/' + item.id)
                    .then((response) => {
                            this.close();
                            this.dialog = false

                            // this.items.splice(index, 1);
                            // this.totalItems = this.totalItems - 1;
                            this.getFromApi();

                        }, (error) => {
                            this.alertDialog = true;
                            // if (error.response.status == 409) {
                            // }
                            this.alertDialogText = "Houve um problema ao remover o registro";
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        // this.errored = true
                    })
                    .finally(() => {
                        this.loading = false;
                        this.loader = null;
                    })
                ;
            }
        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save() {
            this.loading = true;
            this.loader = 'loading';

            if (this.editedIndex > -1) {
                axios
                    .patch('/' + this.endpoint + '/' + this.editedItem.id, this.editedItem)
                    .then((response) => {
                            this.close();

                            // Object.assign(this.items[this.editedIndex], this.editedItem);
                            this.getFromApi();
                        }, (error) => {
                            this.alertDialog = true;
                            // if (error.response.status == 409) {
                            // }
                            this.alertDialogText = "Houve um problema ao modificar o registro";
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        // this.errored = true
                    })
                    .finally(() => {
                        this.loading = false;
                        this.loader = null;
                    })
                ;

            } else {
                axios
                    .post(this.$store.getters.getUsrEndpoint + '/' + this.endpoint, this.editedItem)
                    .then((response) => {
                            // this.items = response.data.items;
                            // this.totalItems = response.data.totalItems;

                            this.close();

                            // this.items.push(this.editedItem);
                            // this.totalItems = this.totalItems + 1;
                            this.getFromApi();

                            this.loading = false;
                        }, (error) => {
                            this.alertDialog = true;
                            this.alertDialogText = error.data.msg;
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        // this.errored = true
                    })
                    .finally(() => {
                        this.loading = false;
                        this.loader = null;
                    })
                ;
            }
        },
        showClientCode() {
            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.client_code) {
                this.clientCode = user.client_code;
            }
        },
    },
}
</script>
